import "./theme/index.css";

import { PersistQueryClientProvider } from "@tanstack/solid-query-persist-client";
import { render } from "solid-js/web";
import { App } from "./App";
import { registerCheatSheetBinding } from "./features/cheat-sheet/cheatSheet";
import { registerPaletteBinding } from "./features/command-palette/palette";
import { Gate } from "./features/gate/gate";
import { startKeyboard } from "./keyboard/manager";
import { demoCapabilities } from "./store/demo";
import {
  CACHE_BUSTER,
  CACHE_MAX_AGE,
  queryClient,
  queryPersister,
  shouldPersistQueryKey,
} from "./store/query";

const root = document.getElementById("app");
if (!root) {
  throw new Error("#app root element is missing");
}

startKeyboard();
registerPaletteBinding();
registerCheatSheetBinding();

render(
  () => (
    <Gate>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister: queryPersister,
          buster: `${CACHE_BUSTER}:${demoCapabilities()?.demoId}:${demoCapabilities()?.incarnationId}`,
          maxAge: CACHE_MAX_AGE,
          dehydrateOptions: {
            shouldDehydrateQuery: (query) =>
              query.state.status === "success" &&
              shouldPersistQueryKey(query.queryKey),
          },
        }}
        onSuccess={() =>
          // Replay issue-status writes queued while offline, then revalidate.
          // A failed revalidate (still offline) is expected, not a crash.
          queryClient
            .resumePausedMutations()
            .then(() => queryClient.invalidateQueries())
            .catch(() => undefined)
        }
      >
        <App />
      </PersistQueryClientProvider>
    </Gate>
  ),
  root,
);
